<template>
    <div class="reo-dialog dialog"
        :class="{
            large: isLargeSize,
            bottom: isBottomWhenMobile
        }"
        :style="styleObject">
        <div class="reo-dialog-inner">
            <button
                v-if="showCloseIcon"
                type="button"
                aria-label="Close"
                class="close close-icon"
                @click="cancel"
            ></button>
            <slot name="top"></slot>
            <div class="dialog-title-container">
                <p :class="[
                       'dialog-title',
                       titleClass
                   ]"
                    :style="{ textAlign: isTitleCentered ? 'center' : 'left' }"
                    v-if="title">{{ title }}
                    <slot name="edit"></slot>
                    <slot name='devicesCount'></slot>
                </p>
            </div>
            <slot name="model-show-des"></slot>
            <div class='scroll-context' @scroll="handleScroll">
                <ul class="des-list" v-if="supportList">
                    <li v-for="(item, index) in supportList" :key="index" class='des-list-block'>
                        <p class="des-title">{{ item.title }}</p>
                        <p class="des-content" v-html='item.content'></p>
                    </li>
                </ul>
                <slot></slot>
            </div>
            <slot name='countrySearch'></slot>
            <slot name='deviceSearch'></slot>
            <slot name='changeSubName'></slot>
            <slot name='note'></slot>
            <slot name='note-not-default-time'></slot>
            <div
                v-if="$slots.attention || showButton"
                :class="[
                    {
                        'dialog-footer': $slots.attention || useActionFooter,
                        'dialog-footer--with-attention': $slots.attention
                    }
                ]"
            >
                <div v-if="$slots.attention" class="dialog-attention">
                    <slot name='attention'></slot>
                </div>
                <dialog-buttons
                    v-if="showButton"
                    :is-mobile="isMobile"
                    :is-button-centered="isButtonCentered"
                    :button-group-class="buttonGroupClass"
                    :custom-width="customWidth"
                    :switch-button="switchButton"
                    :label-of-cancel="labelOfCancel"
                    :label-of-middle="labelOfMiddle"
                    :label-of-confirm="labelOfConfirm"
                    :confirm-disabled="confirmDisabled"
                    :disable-confirm="disableConfirm"
                    @cancel="cancel"
                    @middle="middle"
                    @confirm="confirm"
                />
            </div>
        </div>
    </div>
</template>

<script lang="ts">
import Vue, { PropType } from 'vue';
import DialogButtons from '@/basic/DialogButtons.vue';
import { DIALOG_ADD, DIALOG_REDUCE } from '@/store/mutation-types';
import { mapGetters } from 'vuex';
import reolinkGa from '@/common/js/gtagPageview';

export default Vue.extend({
    components: {
        DialogButtons
    },
    props: {
        title: String,
        titleClass: String,
        description: String,
        labelOfConfirm: String,
        labelOfCancel: String,
        labelOfMiddle: String,
        disableConfirm: Boolean,
        confirmGaLabel: String,
        showButton: {
            type: Boolean,
            default: true
        },
        deviceTip: String,
        supportTip: String,
        supportList: {
            type: Array as PropType<Array<{ title: string; content: string; }>>
        },
        switchButton: {
            default: false,
            type: Boolean
        },
        showCloseIcon: {
            default: true,
            type: Boolean
        },
        isLargeSize: {
            type: Boolean,
            default: false
        },
        isButtonCentered: Boolean,
        maxWidth: {
            type: String,
            default: '620px'
        },
        isBottomWhenMobile: {
            type: Boolean,
            default: false
        },
        isTitleCentered: Boolean,
        buttonGroupClass: {
            type: String,
            default: ''
        },
        useActionFooter: {
            type: Boolean,
            default: false
        },
        closeIconOffset: String
    },
    data () {

        return {
            confirmDisabled: false,
            showTopMore: false,
            showBottomMore: false
        };

    },
    computed: {
        ...mapGetters<'isMobile'>( ['isMobile'] ),
        customWidth(): number | string | undefined {

            if ( this.isMobile ) {

                return '100%';

            }
            if ( this.isLargeSize ) {

                return 253;

            }
            return undefined;

        },
        dialogCount(): number {

            return this.$store.getters.dialogCount;

        },
        styleObject(): Record<string, string> {

            return {
                '--max-width': this.maxWidth,
                ...( this.closeIconOffset ? {
                    '--close-icon-top': this.closeIconOffset,
                    '--close-icon-right': this.closeIconOffset
                } : {})
            };

        }
    },
    mounted () {

        this.dialogMounted();

    },
    destroyed () {

        this.dialogDestroyed();

    },
    methods: {

        confirm () {

            if ( this.confirmGaLabel ) {

                reolinkGa.sendSimpleEvent( this.confirmGaLabel );

            }
            this.$emit( 'confirm' );

        },

        cancel () {

            this.$emit( 'cancel' );

        },
        middle() {

            this.$emit( 'middle' );

        },

        disabledBtn () {

            this.confirmDisabled = true;

        },

        enabledBtn () {

            this.confirmDisabled = false;

        },

        handleScroll ( e ) {

            const { scrollTop, clientHeight, scrollHeight } = e.target;
            this.showTopMore = scrollTop > 0;
            this.showBottomMore = scrollTop + clientHeight < scrollHeight;

        },
        dialogMounted (): void {

            this.$store.commit( DIALOG_ADD );

        },
        dialogDestroyed (): void {

            this.$store.commit( DIALOG_REDUCE );

        }

    }

});

</script>
<style lang="less" scoped>
    /**
        dialog pc缩放规则
        最大高度800px
        居中
        上下有40的padding
        当高度小于800+40*2时，dialog应随高度缩小
     */
    ::-webkit-scrollbar{
        width: 4px;
    }
    ::-webkit-scrollbar-thumb{
        background-color: #CCCCCC;
        border-radius: 8px;
    }
    // 隐藏所有箭头按钮
    ::-webkit-scrollbar-button{
        display: none;
    }
    .dialog.reo-dialog{
        position: fixed;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        background-color: rgba(0, 0, 0, .6);
        z-index: 100;
        margin-top: 0 !important;
        overflow-y: auto;
        @media @snapeak_pc{
            display: flex;
            flex-direction: column;
            justify-content: space-around;
            max-height: 100%;
            padding-top: 100px;
            padding-bottom: 40px;
        }
        @media @snapeak_mobile{
            padding:0 40px;
            width: calc( 100% - 80px );
        }

        .reo-dialog-inner{

            box-sizing: border-box;
            text-align: left;
            margin:0 auto;
            background-color: @bg_02;
            position: relative;
            border-radius: 12px;
            --dialog-padding-top: 16px;
            --dialog-padding-right: 16px;
            @media @snapeak_pc{
                max-width: calc(100% - 80px);
                display: flex;
                flex-direction: column;
                max-height: ~'min(100%, 800px)';
                --dialog-padding-top: 16px;
                --dialog-padding-right: 16px;
                padding: 32px 64px;
            }
            @media @pc{
                max-width: var(--max-width);
            }
            @media @snapeak_mobile{
                display: flex;
                flex-direction: column;
                flex-shrink: 0;
                max-height: 80vh;
                max-height: 80dvh;
                position: fixed;
                top: 50%;
                left: 50%;
                transform: translate(-50%, -50%);
                --dialog-padding-top: 14px;
                --dialog-padding-right: 14px;
                padding: 36px 16px;
                width: 100%;
            }
            .support-tip {
                text-align: left;
                line-height: 1.4;
                max-width: 974px;
                @media @pc{
                    font-size: .16rem;
                    margin-bottom: .16rem;
                }
                @media @mobile{
                    font-size: .26rem;
                    margin-bottom: .2rem;
                }

            }

            .des-list {
                @media @pc{
                    .des-list-block{
                        line-height: normal;
                        background-color: @bg_03;
                        padding: 24px;
                    }
                    .des-title{
                        margin-bottom: 8px;
                        font-size: 18px;
                        font-weight: 500;
                    }
                    .des-content{
                        font-size: 14px;
                        font-weight: 500;
                        display: flex;
                        flex-direction: column;
                        gap: 5px;
                        white-space: pre-line;
                        /deep/ p,span{
                            font-size: 14px;
                            font-weight: 500;
                        }
                    }
                }
                @media @mobile{
                    .des-title{
                        font-size: 16px;
                    }
                    .des-content{
                        font-size: 12px;

                    }
                }

                text-align: left;
                font-size: .18rem;
                // margin-bottom: .4rem;

                li + li {
                    margin-top: 20px;
                }
                .des-title {
                    font-weight: 500;
                }

                @media screen and ( max-width: 1199px ) {
                    font-size: 24px;
                }
            }
            .close{
                padding: 0;
                border: none;
                outline: none;
                appearance: none;
                -webkit-appearance: none;
                display: block;
                background-color: transparent;
                background-image: url('@/common/images/common/dialog/close-default.svg');
                background-position: center;
                background-repeat: no-repeat;
                background-size: contain;
                font-size: 0;
                line-height: 0;
                z-index: 999;
                @media @pc{
                    right: var(--close-icon-right, var(--dialog-padding-right));
                    top: var(--close-icon-top, var(--dialog-padding-top));
                    height: 24px;
                    width: 24px;
                }
                @media @mobile{
                    right: var(--close-icon-right, var(--dialog-padding-right));
                    top: var(--close-icon-top, var(--dialog-padding-top));
                    width: 20px;
                    height: 20px;
                }
                position: absolute;
                cursor: pointer;

                &:hover{
                    background-image: url('@/common/images/common/dialog/close-hover.svg');
                }
            }
        }
        .scroll-context{
            overflow-y: auto;
            .top-shadow{
                height: .15rem;
                position:absolute;
                width:100%;
                background: linear-gradient(0deg, rgba(255,255,255,0) 0%, #FFFFFF 100%);
                z-index: 10;
                @media @pc{
                    margin-left: -0.5rem;
                }

                @media @mobile{
                    margin-left: -0.3rem;
                }
            }
            .bottom-shadow{
                height: .15rem;
                position:absolute;
                width:100%;
                background: linear-gradient(180deg, rgba(255,255,255,0) 0%, #FFFFFF 100%);
                z-index: 10;
                @media @pc{
                    margin-left: -0.5rem;
                    bottom:1.3rem;
                }

                @media @mobile{
                    margin-left: -0.3rem;
                    bottom:1.82rem;
                }
            }

        }
        .scroll-context + p{
            @media @mobile{
                margin: 0 0.3rem;
            }
        }
        .btnBox-horiz{
            @media @snapeak_pc {
                display: flex;
                justify-content: flex-end;
                margin-top: 24px;
                gap: 16px;
            }
            @media @snapeak_mobile {
                display: grid;
                margin-top: 16px;
                gap: 8px;
            }
        }
        .btnBox-vertical {
            display: flex;
            flex-direction: column-reverse;
            justify-content: center;
            @media @snapeak_pc {
                margin-top: 30px;
                gap: 16px;
            }
            @media @snapeak_mobile {
                margin-top: 16px;
                gap: 8px;
            }
        }
        .btnBox-centered{
            justify-content: center;
        }
    }

    .dialog-title-container {
        display: flex;
        align-items: center;
        justify-content: flex-start;
        .devicesCountBox {
            margin-left: 12px;
        }
    }

    .dialog .reo-dialog-inner p.dialog-title{

        font-family: @font_01;
        letter-spacing: 0em;
        color: @font_primary;
        font-weight: 600;
        margin-bottom: 30px;
    }

    .dialog .reo-dialog-inner p.dialog-des{
        font-family: @font_02;
        font-size: 17px;
        font-weight: 500;
        text-align: left;
        display: flex;
        align-items: center;
        letter-spacing: 0px;
        color: @font_primary;
    }
    @media @snapeak_pc{
        .dialog .reo-dialog-inner p.dialog-title{
            font-size: 24px;
            line-height: 1.5;
            text-align: left;
        }

    }
    @media @snapeak_mobile {
        .dialog .reo-dialog-inner{
            max-width: calc(100% - 80px);

        }
        .dialog .reo-dialog-inner p.dialog-des{
            font-size: 14px;
            line-height: 22px;
            // margin-top: 16px;
        }

        .dialog .reo-dialog-inner p.dialog-title{
            font-size: 20px;
            line-height: 1;
            margin-bottom: 16px;
            text-align: center;
        }

    }
    .devices-count /deep/ .reo-tip .tip-icon{
        color:#555;
    }
    .devices-count{
        font-weight: 500;
        color:@font_primary;
        text-align: left;
        font-family: @font_02;
    }
    .devices-count .colon{
        margin-right: .16rem;
    }
    .devices-count .countDesBack{
        margin-left: .08rem;
    }
    @media @pc{
        .devices-count /deep/ .reo-tip .tip-icon{
            font-size: .16rem;
            line-height: 2;
        }
        .devices-count /deep/ .reo-tip{
            margin-left: .04rem;
            margin-right: .04rem;
        }
        .devices-count{
            font-size: .14rem;
            line-height: 2;
        }
        .selectProduct /deep/ .el-table th.el-table__cell:nth-child(1) .cell{
            border-right:none;
        }
    }
    @media @mobile{
        .devices-count /deep/ .reo-tip .tip-icon{
            font-size: .26rem;
            line-height: 1.6;
        }

        .devices-count /deep/ .reo-tip{
            margin-left: .1rem;
            margin-right: .06rem;
        }
        .devices-count{
            font-size: .26rem;
            line-height: 1.6;
            margin-bottom: .08rem;
        }
    }
    .fullSpace.reo-dialog.dialog{
        .reo-dialog-inner{
            min-height:unset;
            .fullSapceWarning{
                font-size: 0.18rem;
                line-height: 1.4;
                text-align: left;
                @media @mobile{
                    font-size: .28rem;
                    margin-right: .3rem;
                }
            }

        }
    }

    .dialog.reo-dialog.large{
        .reo-dialog-inner{
            background-color: @bg_01;
            padding-bottom: 0;
            padding-left: 0;
            padding-right: 0;
            @media @pc{
                max-width: 1220px;
            }
            p.dialog-title{
                padding: 0 80px;
                text-align: center;
                @media @mobile{
                    font-size: 19px;
                }
            }
        }
        .buttons{
            background-color: @bg_02;
            padding: 24px 0;
            margin: 0;
            border-bottom-left-radius: 8px;
            border-bottom-right-radius: 8px;
            display: flex;
            align-items: center;
            justify-content: center;
            @media @mobile{
                padding: 12px 24px;
                background-color: transparent;
            }
        }
    }
    .dialog.reo-dialog.bottom{
        @media @mobile{
            .reo-dialog-inner{
                top: auto;
                bottom: 0;
                left: 0;
                transform: none;
                width: 100vw;
                border-bottom-left-radius: 0;
                border-bottom-right-radius: 0;
                padding-bottom: 20px;
                max-width: none;
            }
        }
    }
    .dialog-footer--with-attention{
        .dialog-attention{
            min-width: 0;
            width: 100%;
        }

        /deep/ .attention{
            box-sizing: border-box;
            width: 100%;
            max-width: none;
        }

        /deep/ .attention p{
            font-family: @font_02;
            font-size: 14px;
            font-weight: 400;
            line-height: 22px;
            letter-spacing: 0;
            color:@font_primary;
            text-align: left;
        }

        /deep/ .attention p + p{
            margin-top: 8px;
        }
    }
    .buttons{
        padding-right: 34px;
        .mobile({
            padding-right: 16px;
        });
    }
    .dialog.reo-dialog.selectProduct{
        .close{
            transform: none !important;
        }

        .dialog-footer{
            flex-shrink: 0;
            position: relative;
            z-index: 100;
            background: linear-gradient(180deg, #f3f4f500 0%, #f3f4f5 14%);
            margin-top: auto;
            @media @mobile{
                display: flex;
                flex-direction: column;
                gap: 12px;
                padding-top: 24px;

                .buttons{
                    position: static;
                    width: 100%;
                    margin: 0;
                    padding: 0;
                    background: transparent;
                    border-radius: 0;
                }
            }
        }

        .scroll-context{
            @media @pc{
                margin-bottom: -30px;
                padding-bottom: 30px;
            }

            @media @mobile{
                margin-bottom: -24px;
                padding-bottom: 24px;
            }
        }

        .dialog-footer--with-attention{
            .buttons{
                margin-top: 0;
            }

            @media @pc{
                display: flex;
                align-items: flex-start;
                gap: 24px;
                padding-top: 24px;

                .dialog-attention{
                    flex: 1;
                }

                /deep/ .attention{
                    padding: 0;
                    margin-top: 0;
                    margin-bottom: 0;
                    background-color: transparent;
                    border-radius: 0;
                }

                .buttons{
                    flex-shrink: 0;
                }
            }

            @media @mobile{
                /deep/ .attention{
                    display: block;
                    padding: 10px;
                    margin-bottom: 0;
                    background-color: @bg_02;
                    border-radius: 10px;
                }
            }
        }

        @media @pc{
            /deep/ .buttons .reo-button-inner{
                padding: 12.5px 45px;
            }
        }

        @media @mobile{
            /deep/ .buttons .reo-button-inner{
                padding-top: 8.5px;
                padding-bottom: 8.5px;
            }
        }

        .buttons{
            padding-right: 0;
        }
    }
</style>
